var map = {
	"./gm01.webp": 1958,
	"./gm02.webp": 1207,
	"./gm03.webp": 9348,
	"./gm04.webp": 5541,
	"./gm05.webp": 4442,
	"./gm06.webp": 3963,
	"./gm07.webp": 1144,
	"./gm08.webp": 8697,
	"./gm09.webp": 8974,
	"./gm10.webp": 5828,
	"./gm11.webp": 7
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8642;